export interface HelpSection {
  title: string;
  image: string;
  description: string;
  points: string[];
}

export const helpSections: HelpSection[] = [
  {
    title: 'マップでスポットを探す',
    image: '/help/map.png',
    description: '地図を動かすと、表示範囲内のスポットが自動的に読み込まれます。',
    points: [
      'ピンをタップするとスポットの概要が表示されます',
      '「現在地」ボタンで現在地に移動します',
      '「スポット一覧」をタップするとスポット一覧を見られます',
      '検索範囲が広すぎる場合は10km圏内に自動的に絞られます',
      '右上の虫眼鏡アイコンをタップすると地名・住所検索ができます。2文字以上入力すると候補が表示され、選択するとその場所にマップが移動します',
    ],
  },
  {
    title: 'スポット一覧',
    image: '/help/spot-list.png',
    description: 'カテゴリや並び順を変えてスポットを探せます。',
    points: [
      'カテゴリボタンで絞り込みができます',
      '距離順・いいね順・チェックイン順・ランク順で並べ替えできます',
      'スポット名をタップすると詳細を確認できます',
    ],
  },
  {
    title: 'スポット詳細',
    image: '/help/spot-detail.png',
    description: 'スポットの詳細情報を確認し、チェックインやいいねができます。',
    points: [
      '「チェックイン」はスポット周辺（約100m以内）にいる必要があります',
      '「いいね」でお気に入りスポットとして記録できます',
      '「ブックマーク」でスポットを保存できます。プロフィールの「ブックマーク」から一覧を確認できます',
      '「ナビ」でGoogleマップのナビを起動します',
      '写真・チェックイン・コメントはタブで切り替えられます',
      'コメントタブでコメントを投稿したり、他の人のコメントに返信できます',
      '自分のコメント・返信は削除ボタンから削除できます（削除前に確認が表示されます）',
      '現地の天気と時間ごとの予報（気温・体感温度・降水確率・風速）が確認できます',
    ],
  },
  {
    title: 'スポットを登録する',
    image: '/help/spot-register.png',
    description: 'ログイン後、マップ画面の「現在地を登録」ボタンから新しいスポットを追加できます。',
    points: [
      'スポット名とカテゴリは必須です',
      '住所は現在地から自動入力されます（任意で修正可）',
      'タグを選ぶと他のライダーが検索しやすくなります',
      'スポットの場所は現在地が自動的に使われます',
    ],
  },
  {
    title: 'ダイレクトメッセージ',
    image: '/help/messages.png',
    description: '他のサイクリストと1対1でメッセージをやり取りできます。',
    points: [
      '他のユーザーのプロフィール画面に「ダイレクトメッセージ」リンクが表示されます',
      'メッセージ送受信はボトムナビの封筒アイコンから一覧を確認できます',
      '未読メッセージがある場合、封筒アイコンに赤いバッジで件数が表示されます',
      '「現在地を送る」ボタンを押すと、現在地を地図カードとして送信できます。受け取った相手はカードをタップするとGoogleマップで自転車ルートのナビが起動します',
      'プッシュ通知を設定している場合、新しいメッセージが届くとプッシュ通知が届きます',
      'プロフィール画面の「アカウント」→「通知設定」でダイレクトメッセージの通知ON/OFFを設定できます',
      '会話画面右上の「…」ボタンからユーザーをブロックできます。ブロックするとメッセージ一覧から相手の会話が非表示になります',
      'ブロック済みのユーザーは「通知設定」→「ブロックリスト」から確認・解除できます',
    ],
  },
  {
    title: 'プロフィール',
    image: '/help/profile.png',
    description: 'チェックイン数や登録スポット数など、自分の活動を確認できます。',
    points: [
      'ベルアイコンをタップすると通知一覧を確認できます。未読通知がある場合は赤いバッジで件数が表示されます',
      'フォロワー数・フォロー中数をタップすると一覧を確認できます',
      '他のユーザーのプロフィールには「フォロー」ボタンが表示されます。フォローするとタイムラインでその人の活動を追えます',
      '「チェックイン」をタップするとチェックイン履歴を見られます',
      '「登録スポット」をタップすると自分が登録したスポット一覧を見られます',
      '「ブックマーク」をタップすると保存したスポット一覧を見られます',
      'バッジ欄でチェックインランク・スポットランクを確認できます',
      'アワードギャラリーには月間・年間の上位入賞歴が表示されます',
      '「プロフィール編集」でニックネーム・アイコン画像・自己紹介を変更できます',
      '「アカウント」→「通知設定」でプッシュ通知の許可とON/OFF設定ができます',
      '「アカウント」→「通知設定」→「ブロックリスト」でブロック中のユーザーを管理できます',
      '「ギア紹介」欄に愛車・装備情報を登録してアピールできます',
      '「友達に紹介する」でアプリのURLを共有できます',
      '「フィードバックを送る」からご意見をお寄せください',
    ],
  },
];
